export enum FeatureTypeEnum {
    NEW = 'NEW',
    IMPROVED = 'IMPROVED',
    FIXED = 'FIXED',
}
